
define('text!core/controllers/Error-404.html',[],function () { return '<section class="page pagePadded">\n\t<header class="pageHeader">\n\t\t<h1 class="pageTitle">{{\'core.pageNotFound.title\'|i18n}}</h1>\n\t</header>\n\t<p data-ng-controller="ErrorController">\n\t\t{{\'core.pageNotFound\'|i18n}}\n\t</p>\n</section>\n';});

